/**
 * Les variables d'un message patient et leur remplacement par des exemples.
 *
 * Partagé entre l'app cabinet (éditeur) et la console admin (aperçu d'un
 * modèle de cabinet) : un même aperçu, les mêmes exemples.
 */

/** Ce qui s'affiche en tête du courriel reçu par le patient. */
export type Sender = { nom: string; email: string };

/**
 * Ce qu'on peut insérer dans le corps du message.
 *
 * Le libellé sert au bouton, l'exemple à l'aperçu. Les deux sont nécessaires :
 * « {{praticien}} » ne dit pas à quoi ressemblera la phrase une fois remplacé.
 */
export type Variable = {
  cle: string;
  libelle: string;
  exemple: string;
};

export const VARIABLES: readonly Variable[] = [
  { cle: 'prenom', libelle: 'Prénom', exemple: 'Camille' },
  { cle: 'nom', libelle: 'Nom', exemple: 'Dupont' },
  { cle: 'praticien', libelle: 'Nom praticien', exemple: 'Dr SAYADA' },
  { cle: 'emailPraticien', libelle: 'Email praticien', exemple: 'dr.sayada@exemple.fr' },
  { cle: 'motif', libelle: 'Motif', exemple: 'Détartrage' },
  { cle: 'date', libelle: 'Date', exemple: 'mardi 7 octobre' },
  { cle: 'heure', libelle: 'Heure', exemple: '14 h 30' },
  { cle: 'cabinet', libelle: 'Cabinet', exemple: 'votre cabinet' },
];

/**
 * Remplace les variables par leur exemple, pour l'aperçu.
 *
 * `cabinet` est passé à part quand on le connaît : c'est le nom du vrai
 * cabinet, et l'aperçu doit montrer ce que le patient lira, pas un exemple.
 */
export function apercu(corps: string, cabinet?: string): string {
  return corps.replace(/\{\{(\w+)\}\}/g, (entier, cle: string) => {
    if (cle === 'cabinet' && cabinet) return cabinet;
    const variable = VARIABLES.find((candidate) => candidate.cle === cle);
    return variable ? variable.exemple : entier;
  });
}
